(function () {
  var MUSTER = 'a[href$="#cookie-einstellungen"]';

  function umschreiben() {
    document.querySelectorAll(MUSTER).forEach(function (a) {
      a.setAttribute('href', '#reopenBanner');
      a.setAttribute('data-cookie-einstellungen', '');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', umschreiben);
  else umschreiben();

  document.addEventListener('click', function (e) {
    var link = e.target.closest(MUSTER + ', a[data-cookie-einstellungen]');
    if (!link) return;
    if (window.Pandectes && typeof window.Pandectes.openDialog === 'function') {
      e.preventDefault();
      window.Pandectes.openDialog('preferences');
    } else if (!document.querySelector('script[src*="pandectes-core"]') &&
               window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      e.preventDefault();
      window.privacyBanner.showPreferences();
    }
  });
})();
